// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"breadcrumbs-Cxf0C","separator":"separator-bjQhR"};